export default "__VITE_ASSET__C7Zu5DKK__"